import template from './offers.html';
import { groupBy } from 'lodash-es';
import { actions, selectors } from '../../../state';
import './offers.global.css';
import { trackEngagement } from '@mover-app/engagement';
import { ITEM_DEFINITION_CODES } from '../../../constants';

const CATEGORIES = {
  MOVE: 'move',
  LIFE: 'life',
};

class OffersController {
  constructor(updStore) {
    'ngInject';
    Object.assign(this, {
      updStore,
      category: CATEGORIES.MOVE,
      categories: CATEGORIES,
      offers: {},
    });
  }

  $onInit() {
    const { connect, dispatch } = this.updStore;
    trackEngagement({
      code: ITEM_DEFINITION_CODES.OFFER,
      name: 'Legacy Offers',
    });

    dispatch(actions.offer.read());
    this.disconnect = connect(mapStateToThis)(this);
  }

  get moveInOffers() {
    return this.offers[this.category] || [];
  }

  isActiveCategory(category) {
    return this.category === category;
  }

  changeCategory(category) {
    this.category = category;
  }

  $onDestroy() {
    this.disconnect();
  }
}

export const OffersComponent = {
  template,
  controller: OffersController,
};

function mapStateToThis(state) {
  const offers = selectors.offer
    .all(state)
    .map(mapOffer(state))
    .sort((a, b) => a.order - b.order);

  return {
    loading: selectors.pending.match(actions.offer.isRead, state),
    haveOffers: !!(offers || []).length,
    offers: groupByCategory(offers),
  };
}

function mapOffer(state) {
  return offer => ({
    id: offer.id(state),
    action: offer.action(state),
    category: offer.category(state),
    logoId: offer.logoId(state),
    description: offer.description(state),
    detail: offer.detail(state),
    company: offer.company(state),
    link: offer.link(state),
    trackingId: offer.trackingId(state),
    subcategory: offer.subcategory(state),
    order: offer.order(state),
  });
}

function groupByCategory(offers) {
  return groupBy(offers, offer => offer.category.toLowerCase());
}
